import { useTranslation } from 'react-i18next'
import { UploadFile } from './components'
import { FC } from 'react'

type UploadFileBlockProps = {
  onDrop: () => void
}

export const UploadFileBlock: FC<UploadFileBlockProps> = ({ onDrop }) => {
  const { t } = useTranslation()
  const TRANSLATION_BASE_KEY = 'userArea.profile.actions.upload'

  return (
    <div className="flex flex-col gap-2 mb-6">
      <div className="text-primary text-xl font-semibold mb-4">
        {t(`${TRANSLATION_BASE_KEY}.title`)}
      </div>
      <UploadFile onDrop={onDrop} />
    </div>
  )
}
